import React, {useState} from 'react';
import {Tab, Tabs, AppBar} from '@material-ui/core';
import VideoList from './VideoList';
import Photoes from '../../photos/Photoes';
import './Videos.css';

function Videos() {
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (e, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <div className="videos-container">
      <AppBar
        position="static"
        style={{
          backgroundColor: 'white',
          color: 'black',
          padding: '20px 0',
          boxShadow: 'none',
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          className="musicTab__container"
          centered
        >
          <Tab label="Videos" />
          <Tab label="Photos" />
        </Tabs>
      </AppBar>
      {selectedTab === 0 && <VideoList />}
      {selectedTab === 1 && <Photoes />}
    </div>
  );
}

export default Videos;
